// extracted by mini-css-extract-plugin
module.exports = {"comment":"AddComment_comment__g6Geh","form-add-comment":"AddComment_form-add-comment__3xfYn"};